
.gallery {
  --covet-pics-desktop-item-width: calc((100 - (var(--covet-pics-desktop-photos-per-row) - 1) * var(--covet-pics-desktop-item-padding)) / var(--covet-pics-desktop-photos-per-row));
  --covet-pics-mobile-item-width: calc((100 - (var(--covet-pics-mobile-photos-per-row) - 1) * var(--covet-pics-mobile-item-padding)) / var(--covet-pics-mobile-photos-per-row));

  --covet-pics-desktop-highlighted-width: calc(var(--covet-pics-desktop-item-width) * 2 + var(--covet-pics-desktop-item-padding));
  --covet-pics-mobile-highlighted-width: calc(var(--covet-pics-mobile-item-width) * 2 + var(--covet-pics-mobile-item-padding));

  --covet-pics-desktop-grid-space: calc(100 * 100 / var(--covet-pics-desktop-item-width) * var(--covet-pics-desktop-item-padding) / 100);
  --covet-pics-mobile-grid-space: calc(100 * 100 / var(--covet-pics-mobile-item-width) * var(--covet-pics-mobile-item-padding) / 100);

  margin: 0;
  padding: 0;
  list-style: none;
  display: block;

  &.grid {
    display: grid;
    grid-template-columns: repeat(var(--covet-pics-mobile-photos-per-row), calc(var(--covet-pics-mobile-item-width) * 1%));
    column-gap: calc(var(--covet-pics-mobile-item-padding) * 1%);
    // for testing auto-fill empty space
    grid-auto-flow: dense;
  }
}

.grid-sizer {
  width: calc(var(--covet-pics-mobile-item-width) * 1%);
}

.gutter-sizer {
  width: calc(var(--covet-pics-mobile-item-padding) * 1%);
}

@media only screen and (min-width: 800px) {
  .gallery.grid {
    grid-template-columns: repeat(var(--covet-pics-desktop-photos-per-row), calc(var(--covet-pics-desktop-item-width) * 1%));
    column-gap: calc(var(--covet-pics-desktop-item-padding) * 1%)
  }

  .grid-sizer {
    width: calc(var(--covet-pics-desktop-item-width) * 1%);
  }
  
  .gutter-sizer {
    width: calc(var(--covet-pics-desktop-item-padding) * 1%);
  }
}

.loading-animation {
  display: none;
  justify-content: center;
  svg {
    width: 50px;
    height: 50px;

    circle {
      fill: var(--covet-pics-load-more-color);
    }
    .dot-2, .dot-3 {
      opacity: 0.4;
    }
  }

  &.show {
    display: flex;
  }
}

.load-more {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-load-more {
  font-size: var(--covet-pics-load-more-font-size);
  font-weight: var(--covet-pics-load-more-font-style);
  font-family: inherit;
  color: var(--covet-pics-load-more-color);
  background: none;
  border:0px solid;
  margin:20px 0;
  display: inline-block;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover, &:active, &:focus {
    opacity: 0.7;
  }

  .icon {
    display: flex;
    margin-left: 8px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &.btn_style_1 {
    padding:0 0 var(--covet-pics-load-more-padding) 0;
    border-bottom: var(--covet-pics-load-more-border) solid var(--covet-pics-load-more-color);

    .icon {
      display: none;
    }
  }

  &.btn_style_2 {
    padding: var(--covet-pics-load-more-padding) calc(var(--covet-pics-load-more-padding) * 2);
    border: var(--covet-pics-load-more-border) solid var(--covet-pics-load-more-color);

    .icon {
      display: none;
    }
  }

  &.btn_style_3 {
    padding: var(--covet-pics-load-more-padding) calc(var(--covet-pics-load-more-padding) * 2);
    border: var(--covet-pics-load-more-border) solid var(--covet-pics-load-more-color);

    .icon {
      width: var(--covet-pics-load-more-font-size);
      height: var(--covet-pics-load-more-font-size);
      display:flex;
      margin-left:8px;

      svg {
        .dynamic-stroke {
          stroke: var(--covet-pics-load-more-color)
        }
      }
    }
  }

  &.btn_style_4 {
    .text {
      display: none;
    }

    .icon {
      width: 32px;
      height: 32px;
      margin: 0;

      svg {
        path {
          fill: var(--covet-pics-load-more-color)
        }
      }
    }
  }

  &.btn_style_5 {
    .text {
      display: none;
    }

    .icon {
      width: 42px;
      height: 42px;
      margin: 0;

      svg {
        path {
          fill: var(--covet-pics-load-more-color)
        }
      }
    }
  }
}

/*
* Filters: begin
*/

.filters {
  .btn-filter {
    padding-left: var(--covet-pics-filter-padding);
    padding-right: var(--covet-pics-filter-padding);
    margin-top: var(--covet-pics-filter-padding);
    margin-bottom: var(--covet-pics-filter-padding);
    text-decoration: none;
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    opacity: 0.8; //TODO errow with accessibiblity with font-weight 400 and opacity 0.7 for most of colors 
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: var(--covet-pics-filter-font-size);
    font-family: var(--covet-pics-font-family);
    font-weight: var(--covet-pics-filter-font-weight);
    color: var(--covet-pics-filter-font-color);
    border: none;
    background-color: transparent;
    outline: none !important;
    &:hover, &:active, &:focus, &.selected {
      opacity: 1;
    }
  }

  .btn-filter + .btn-filter {
    border-left: 1px solid var(--covet-pics-filter-font-color);
    line-height: var(--covet-pics-filter-font-size);
  }
}

/*
* Filters: end
*/
